import { Injectable } from "@angular/core";
import { PinService } from "@docma-mm-core/pin/pin-service";
import { Project } from "@docma-mm-core/project/project";
import { BpPin, BpPinLocationTargetEnum } from "../bp-common/models/bp-pin";
import { Coordinate } from "@docma-mm-core/plan/plan";
import { FaultService } from "@docma-mm-core/fault/fault.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Injectable()
export class MmPinsLoaderService{



  private pinsByUid = new Map<string, BpPin>();
  private project: Project;

  constructor(private readonly pinService: PinService, private readonly faultService: FaultService) {
    this.faultService.onFaultChanged
    .pipe(untilDestroyed(this))
    .subscribe(fault=> {
      this.pinsByUid.set(fault.uid, fault.data.Pin);
    })

    this.faultService.onFaultDeleted
    .pipe(untilDestroyed(this))
    .subscribe(fault=> {
      this.pinsByUid.delete(fault.uid);
    })
  }


  public addPin(p: BpPin ) {
    this.pinsByUid.set(p.ExternalId, p);
  }

  public reset() {
    this.pinsByUid.clear();
  }

  async loadPins(project: Project): Promise<BpPin[]> {
    this.reset();
    if (!project?.BPConnected) {
      return [];
    }
    const pins = await this.pinService.getProjectPins(project);
    (pins || []).forEach(p=> {
      this.pinsByUid.set(p.ExternalId, p);
    })
    return pins;
  }

  convertToCoordinate(pin:BpPin): Coordinate {
    const planLocation = (pin.Locations || []).find(l=> l.Type === BpPinLocationTargetEnum.plan);
    if (planLocation) {
      return {
        PosX: planLocation.X * 100,
        PosY: planLocation.Y * 100,
        RelativeAnchorToParentPosX: planLocation.Marker?.Location?.X,
        RelativeAnchorToParentPosY: planLocation.Marker?.Location?.Y,
        FileId: planLocation.ModelId as any
      }
    }
    return null;
  }

  getPinByFaultUid(uid: string): BpPin {
    return this.pinsByUid.get(uid);
  }

}
